import {
  pipe,
  map,
  reduce,
  propEq,
  set,
  lensPath,
  path,
  mergeLeft,
  pathOr,
  find,
  prop,
  values
} from 'ramda'
import { normalizingSignee } from './normalize'

const updateAt = (state, at, payload) => set(lensPath(at), payload, state)

const patch = (state, at, payload) =>
  set(lensPath(at), pipe(path(at), mergeLeft(payload))(state), state)

const parsePDFImagesAndDPIs = currentDocument => {
  let urls = []
  let dpis = []

  if (!!currentDocument?.files_metadata.images) {
    for (let [key] of Object.entries(currentDocument?.files_metadata.images)) {
      urls.push(currentDocument?.files_metadata?.images?.[key]?.location)
      dpis.push(currentDocument?.files_metadata?.images?.[key]?.resolution)
    }
  }
  return [urls, dpis]
}

const getFormattedPackageFiles = pipe(
  map((file = {}) => ({
    ...file,
    file_id: file?.id,
    file_original_name: file?.file_original_name,
    fields_metadata: file?.fields_metadata,
    location: parsePDFImagesAndDPIs(file)
  }))
)

const getFormattedSigners = pipe(
  Object.entries,
  reduce(
    (acc, [key, value]) => ({
      ...acc,
      [key]: normalizingSignee(value)
    }),
    {}
  )
)

const getIsCreator = value =>
  pipe(
    pathOr([], ['contract_documents']),
    find(propEq('document_type', 'tenancy_agreement')),
    prop('is_creator')
  )(value)

const displayExistingItems = (items = {}, signees = {}) => {
  let existingItems = []

  Object.values(items)?.forEach(pageItem => {
    pageItem.forEach(item => {
      const konvaId = item.metadata.konva_id.slice(0, item.metadata.konva_id.lastIndexOf('-'))
      const [recipientId] = konvaId?.split('_')

      existingItems.push({
        id: konvaId,
        name: `page-${item.page}`,
        stroke: item.metadata.konva_coordinates.color,
        text:
          item.metadata.konva_display_text ||
          `${item.type.charAt(0).toUpperCase() + item.type.slice(1)} field`,
        height: item.metadata.konva_coordinates.height,
        width: item.metadata.konva_coordinates.width,
        x: item.metadata.konva_coordinates.x,
        y: item.metadata.konva_coordinates.y,
        inputType: item.type,
        textSize: item.metadata.konva_display_text_size,
        recipient_id: recipientId
      })
    })
  })
  return existingItems
}
const getPrimary = pipe(values, find(getIsCreator))

const getPrimaryLandlord = (recipients, signees) => {
  const primaryLandlord = getPrimary(recipients)

  const primaryLandlordColor = pipe(
    values,
    prop(0),
    values,
    find(propEq('recipient_id', primaryLandlord.recipient_id)),
    prop('color')
  )(signees)

  return {
    name: `${primaryLandlord.first_name} ${primaryLandlord.last_name}`,
    email: primaryLandlord.email,
    id: primaryLandlord.user_id,
    recipient_id: primaryLandlord.recipient_id,
    color: primaryLandlordColor
  }
}

export {
  updateAt,
  patch,
  parsePDFImagesAndDPIs,
  getFormattedPackageFiles,
  getFormattedSigners,
  getIsCreator,
  displayExistingItems,
  getPrimaryLandlord
}
